import {
  enableProdMode,
  importProvidersFrom,
  provideExperimentalZonelessChangeDetection,
  provideEnvironmentInitializer,
} from '@angular/core';
import { environment } from '@env/environment';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AuthHttpInterceptor, AuthModule } from '@auth0/auth0-angular';
import { LoginRequiredInterceptor } from '@app/common/interceptors/login-required.interceptor';
import { API_BASE_URL } from 'src/app/common/services';
import { HttpLoaderFactory, initializeDialogService } from '@app/app.module';
import { createMongoAbility, PureAbility } from '@casl/ability';
import { windowProvider } from '@app/common/services/window.service';
import { AbilityService } from '@casl/angular';
import { provideNgxMask } from 'ngx-mask';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { AppRoutingModule } from '@app/app-routing.module';
import { toAuthCallback } from '@app/common/routes';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { AppComponent } from '@app/app.component';
import { CurrencyPipe, DecimalPipe } from '@angular/common';
import { DecimalPipeWithCustomFormat } from '@app/common/pipes/decimal-pipe';
import { CurrencyPipeWithCustomFormat } from '@app/common/pipes/currency-pipe';
import { AppAbility } from '@app/features/auth/app-ability';
import { FullscreenOverlayContainer, OverlayContainer } from '@angular/cdk/overlay';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    provideExperimentalZonelessChangeDetection(),
    importProvidersFrom(
      AppRoutingModule,
      AuthModule.forRoot({
        domain: environment.auth0.domain,
        clientId: environment.auth0.clientId,
        cacheLocation: 'localstorage',
        authorizationParams: {
          redirect_uri: window.location.origin + toAuthCallback(),
          audience: environment.auth0.audience,
          scope: 'openid profile email',
        },
        httpInterceptor: {
          allowedList: [
            {
              uri: environment.apiUrl + '/*',
            },
          ],
        },
      }),
      TranslateModule.forRoot({
        defaultLanguage: environment.defaultLanguage,
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        },
      }),
    ),
    { provide: HTTP_INTERCEPTORS, useClass: AuthHttpInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LoginRequiredInterceptor, multi: true },
    { provide: API_BASE_URL, useValue: environment.apiUrl },
    { provide: PureAbility, useValue: createMongoAbility<AppAbility>() },
    { provide: OverlayContainer, useClass: FullscreenOverlayContainer },
    provideEnvironmentInitializer(() => {
      const initializerFn = initializeDialogService();
      return initializerFn();
    }),
    {
      provide: DecimalPipe,
      useValue: new DecimalPipeWithCustomFormat(),
    },
    {
      provide: CurrencyPipe,
      useValue: new CurrencyPipeWithCustomFormat(),
    },
    windowProvider,
    AbilityService<AppAbility>,
    provideNgxMask({
      decimalMarker: ['.', ','],
    }),
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),
  ],
}).catch((err) => console.error(err));
